import apiService from "../../api/api.service";
import {
  GetCheckoutResponse,
  CreateCheckoutRequest,
  CreateCheckoutResponse,
  GetCheckoutSessionResponse,
  CreateAddressResponse,
  UpdateAddressResponse,
  UpdateShippingAddressRequest,
  UpdateShippingAddressResponse,
  UpdateBillingAddressRequest,
  UpdateBillingAddressResponse,
  GetInstallmentOptionsRequest,
  GetInstallmentOptionsResponse,
  CheckoutSummaryResponse,
  GetCheckoutParams,
} from "./checkout.types";
import {
  CreateAddressRequest,
  UpdateAddressRequest,
} from "../address/address.types";

/**
 * Seçili adreslerle çekilir: sözleşmeler, kargo bilgisi ve özet adrese göre
 * değişebiliyor. Parametre yoksa backend kendi varsayılan adreslerini kullanır
 * (ilk yükleme). Boş/NaN id'ler query'ye YAZILMAZ — "shipping_address_id=NaN"
 * gitmesindense parametresiz istek doğru davranış.
 */
export const fetchCheckout = (params?: GetCheckoutParams) => {
  const query = new URLSearchParams();
  if (Number.isFinite(params?.shipping_address_id)) {
    query.set("shipping_address_id", String(params!.shipping_address_id));
  }
  if (Number.isFinite(params?.billing_address_id)) {
    query.set("billing_address_id", String(params!.billing_address_id));
  }
  const qs = query.toString();
  return apiService.get<GetCheckoutResponse>(
    qs ? `/checkout?${qs}` : "/checkout",
  );
};

export const createCheckout = (data: CreateCheckoutRequest) => {
  return apiService.post<CreateCheckoutResponse, CreateCheckoutRequest>(
    "/checkout",
    data,
  );
};

export const fetchCheckoutSession = (token: string) => {
  return apiService.get<GetCheckoutSessionResponse>(`/checkout/${token}`);
};

export const createAddress = (data: CreateAddressRequest) => {
  return apiService.post<CreateAddressResponse, CreateAddressRequest>(
    "/checkout/address",
    data,
  );
};

export const updateAddress = (addressId: number, data: UpdateAddressRequest) => {
  return apiService.put<UpdateAddressResponse, UpdateAddressRequest>(
    `/checkout/address/${addressId}`,
    data,
  );
};

export const resendOtp = (data: import("./checkout.types").CheckoutOtpRequest) => {
  return apiService.post<import("./checkout.types").CheckoutResendOtpResponse>(
    "/checkout/resend-otp",
    data,
  );
};

export const verifyOtp = (data: import("./checkout.types").CheckoutVerifyOtpRequest) => {
  return apiService.post<import("./checkout.types").CheckoutVerifyOtpResponse>(
    "/checkout/verify-otp",
    data,
  );
};

export const updateShippingAddress = (
  token: string,
  data: UpdateShippingAddressRequest,
) => {
  return apiService.patch<
    UpdateShippingAddressResponse,
    UpdateShippingAddressRequest
  >(`/checkout/${token}/shipping-address`, data);
};

export const updateBillingAddress = (
  token: string,
  data: UpdateBillingAddressRequest,
) => {
  return apiService.patch<
    UpdateBillingAddressResponse,
    UpdateBillingAddressRequest
  >(`/checkout/${token}/billing-address`, data);
};

export const fetchInstallmentOptions = (data: GetInstallmentOptionsRequest) => {
  return apiService.post<GetInstallmentOptionsResponse, GetInstallmentOptionsRequest>(
    "/checkout/installment-options",
    data,
  );
};

export const fetchCheckoutSummary = (payment_method: string) => {
  return apiService.post<CheckoutSummaryResponse>("/checkout/summary", { payment_method });
};